import { render, staticRenderFns } from "./ContactCreate.vue?vue&type=template&id=5fd62710&"
import script from "./ContactCreate.vue?vue&type=script&lang=js&"
export * from "./ContactCreate.vue?vue&type=script&lang=js&"
import style1 from "./ContactCreate.vue?vue&type=style&index=1&id=5fd62710&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports